
// Only supported in browsers
export default window.crypto;
